



























import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import {
  getMasterConstructionTask,
  getOperatorFilterOptions
} from "@/servicetask/api/service-schedule-list-api";
import { getAllClients } from "@/api/client-api";

export interface SearchScheduleBarFormData {
  client?: string;
  operator?: string;
  constructionTask?: string;
}

@Component({})
export default class SearchScheduleBar extends Vue {
  @Prop({ required: true }) serviceTaskTypeId!: number;
  @Prop({ default: () => {} }) defaultQuery!: SearchScheduleBarFormData;

  clientOptions: SelectOption[] = [];
  operatorOptions: SelectOption[] = [];
  constructionTaskOptions: SelectOption[] = [];

  query: SearchScheduleBarFormData = {
    client: "",
    operator: "",
    constructionTask: ""
  };

  @Watch("defaultQuery", { immediate: true })
  onDefaultValuesChanged() {
    this.query = { ...this.query, ...this.defaultQuery };
  }

  @Watch("serviceTaskTypeId", { immediate: true })
  onServiceTaskTypeChanged() {
    this.initOptions();
  }

  search() {
    this.$emit("search", this.query);
  }

  initOptions(): void {
    this.getClientOptions().then(options => {
      this.clientOptions = [
        {
          text: "すべての発注者",
          value: ""
        }
      ].concat(options);
    });
    // 工程表に使用されている施工者だけをオプションとして取得する
    getOperatorFilterOptions({
      serviceTaskTypeId: String(this.serviceTaskTypeId)
    }).then(options => {
      this.operatorOptions = [
        {
          text: "すべての施工者",
          value: ""
        }
      ].concat(options);
    });
    this.getConstructionTaskOptions().then(options => {
      this.constructionTaskOptions = [
        {
          text: "すべてのタスク",
          value: ""
        },
        {
          text: "未完了",
          value: "-1"
        }
      ].concat(options);
    });
  }

  async getClientOptions(): Promise<SelectOption[]> {
    return (await getAllClients()).map(c => ({
      text: c.name,
      value: String(c.id)
    }));
  }

  async getConstructionTaskOptions(): Promise<SelectOption[]> {
    return (await getMasterConstructionTask(
      String(this.serviceTaskTypeId)
    )).map(
      // TODO 型をつける
      (c: any) => ({
        text: c.name,
        value: String(c.id)
      })
    );
  }
}
